// import { getAboutPage } from 'utils/api';
import { GetStaticProps } from 'next';
import React from 'react';

import AboutPage from 'containers/AboutPage';
import { queryCMS } from 'utils/cms/api';
import { aboutPageQuery, employeesQuery, footerQuery } from 'utils/cms/gql';
import { ISR_TIMEOUT } from 'utils/config';

const Component = props => {
  return <AboutPage {...props} />;
};

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  const aboutPageResults = await queryCMS({
    query: aboutPageQuery({ locale }),
  });

  const projectAwards = aboutPageResults.projects.map(({ awards }) =>
    awards.map(({ name }) => name)
  );

  aboutPageResults.aboutPage.awards = aboutPageResults.aboutPage.awards.map(
    award => {
      let countValue = 0;
      for (const projectAward of projectAwards) {
        projectAward.includes(award.name) && (countValue += 1);
      }

      return {
        ...award,
        count: award.count + countValue,
      };
    }
  );

  const employeesResults = await queryCMS({
    query: employeesQuery(),
  });

  // Remove duplicates with featured
  let parsedEmployees = employeesResults.employees.filter(
    employee =>
      !aboutPageResults.aboutPage.featuredEmployees.find(
        e => e.id === employee.id
      )
  );

  // Remove last names for other employees
  parsedEmployees = employeesResults.employees.map(employee => {
    delete employee.lastName;
    return employee;
  });

  const footerResults = await queryCMS({
    query: footerQuery({ locale }),
  });

  return {
    props: {
      ...aboutPageResults.aboutPage,
      employees: parsedEmployees,
      footer: footerResults.footer,
    },
    revalidate: ISR_TIMEOUT,
  };
};

export default Component;
